import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["submitButton", "ratingInput"];

  declare readonly submitButtonTarget: HTMLButtonElement;
  declare readonly ratingInputTargets: HTMLInputElement[];

  validateForm() {
    const ratingSelected = this.ratingInputTargets.some(
      (input) => input.checked
    );
    this.submitButtonTarget.disabled = !ratingSelected;
  }

  handleSubmit(event: CustomEvent) {
    if (event.detail.success) {
      (
        this.element.closest("[data-modal-target='modal']") as HTMLElement
      )?.classList.add("hidden");
    }
  }
}
